import { render, staticRenderFns } from "./PesquisaQualidadeVida.vue?vue&type=template&id=730441fc&scoped=true"
import script from "./PesquisaQualidadeVida.vue?vue&type=script&lang=js"
export * from "./PesquisaQualidadeVida.vue?vue&type=script&lang=js"
import style0 from "./PesquisaQualidadeVida.vue?vue&type=style&index=0&id=730441fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730441fc",
  null
  
)

export default component.exports